// extracted by mini-css-extract-plugin
module.exports = {"item":"MenuItemCard__item___YZn5i","wrapper":"MenuItemCard__wrapper___7Gowo","name":"MenuItemCard__name___3Kejv","price":"MenuItemCard__price___-2QFa"};